function popover(){

    "use strict";

    $('[data-toggle="popover"]').popover({
        placement : 'top',
        html : true
    });
    $(document).on("click", ".popover .popover__close" , function(){
        $(this).parents(".popover").popover('hide');
    });

}

module.exports = popover;


// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/components/global/12_popover.js